// PhonicsLt08.js
// 包装组件：Letter Teams L08
// 路由：/phonics/lt08
import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterDataLt08 } from './phonics/phonics_data_lt08';

function PhonicsLt08() {
  return <PhonicsLt letterData={letterDataLt08} />;
}

export default PhonicsLt08;
